import { useEffect, useState } from 'react';
import classes from "./MainProductDescription.module.scss";

const MOBILE_MAX_WIDTH = 768;
const DEFAULT_MAX_LENGTH = 160;
const MOBILE_MAX_LENGTH = 100;

const MainProductDescription = ({ description }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  let maxLength = DEFAULT_MAX_LENGTH;


  useEffect(() => {
    if (typeof window !== 'undefined' && window.innerWidth <= MOBILE_MAX_WIDTH) {
      maxLength = MOBILE_MAX_LENGTH;
    }
  }, [])

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  let displayDescription;
  if (isExpanded) {
    displayDescription = description;
  } else {
    displayDescription = description?.length > maxLength
      ? `${description.substring(0, maxLength)}...`
      : description;
  }

  return (
    <div className={classes["description-container"]}>
      <p className={classes["description"]}>
        {displayDescription}
        {description?.length > maxLength && (
          <span className={classes["read-more"]} onClick={handleToggle}>
            {isExpanded ? 'Read less' : 'Read more'}
          </span>
        )}
      </p>
    </div>
  );
};

export default MainProductDescription;
